const SvgIconTokenomics = (props) => (
  <svg viewBox="0 0 105 105" xmlns="http://www.w3.org/2000/svg">
    <path d="M0 0V105H105L0 0Z" fill="#BC6038" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M24.6295 24.6629C17.5011 31.7914 13.0921 41.6392 13.0921 52.5168C13.0921 74.2721 30.7282 91.9082 52.4834 91.9082C63.361 91.9082 73.2089 87.4992 80.3373 80.3707L24.6295 24.6629Z"
      fill="#29A964"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M24.6294 24.6631C31.7578 17.5344 41.6058 13.1252 52.4836 13.1252C74.2389 13.1252 91.875 30.7614 91.875 52.5166C91.875 63.8908 87.0542 74.1391 79.3444 81.3297C79.6808 81.0158 80.0118 80.6961 80.3371 80.3708L24.6294 24.6631Z"
      fill="#F2D6BB"
    />
  </svg>
);

export default SvgIconTokenomics;
